import dynamic from 'next/dynamic'
import { type FC } from 'react'

import { type PimProductV11 } from '@redteclab/api/clients/bully'

import {
  type CrossSellConfigContext,
  useCrossSellConfigContext,
} from '../../../../cross-sell'
import { crossSellAccessorIsExceptionFlagActiveInProduct } from '../../../model/crossSellAccessor/crossSellAccessorIsExceptionFlagActiveInProduct'
import { productAccessorStockStatusIsAvailable } from '../../../model/productAccessor/productAccessorStockStatusIsAvailable'
import { PRODUCT_TEMPLATES } from '../../../model/productTemplates'
import { useProductPageContext } from '../../productPageContext'

const shouldRenderCrossSellBuyTogether = ({
  crossSellConfig,
  currentVariant,
  productTemplate,
}: {
  crossSellConfig: CrossSellConfigContext
  currentVariant: PimProductV11
  productTemplate: PRODUCT_TEMPLATES
}): boolean => {
  const isRx = productTemplate === PRODUCT_TEMPLATES.RX

  if (!productAccessorStockStatusIsAvailable(currentVariant) || isRx) {
    return false
  }

  if (
    crossSellAccessorIsExceptionFlagActiveInProduct({
      crossSellConfig,
      currentVariant,
    })
  ) {
    return false
  }

  return true
}

const DynamicProductCrossSellBuyTogetherInner = dynamic(async () =>
  import('./ProductCrossSellBuyTogether').then(
    (mod) => mod.ProductCrossSellBuyTogether,
  ),
)

export const DynamicProductCrossSellBuyTogether: FC = () => {
  const { currentVariant, productTemplate } = useProductPageContext()
  const crossSellConfig = useCrossSellConfigContext()

  if (
    !shouldRenderCrossSellBuyTogether({
      crossSellConfig,
      currentVariant,
      productTemplate,
    })
  ) {
    return null
  }

  return <DynamicProductCrossSellBuyTogetherInner />
}
